import React, {useState, useEffect, memo} from "react";
import styles from "./Input.module.sass";
import masks from "../../../../utils/masks";
import Tooltip from "../../Tooltip/Tooltip";

const getErrorMessageClass = (isValid, validation) => styles.errorMsg + (isValid === false || (isValid !== false && !validation.isValid) ?  ` ${styles.invalid}` : "")
const getInputItemClass = (isValid, validation) => styles.inputItem + (isValid === false || (isValid !== false && !validation.isValid) ? ` ${styles.error}` : '')
const callOnChange = (text, mask, onChange, name) => {
  if(mask){
    return onChange(mask === masks.currency ? mask(text) : text.replace(/[^a-z0-9]/gi, ""), name)
  }else{
    return onChange(text, name)
  }

};

const getInputStyle = (props, validation) => [getInputItemClass(props.isValid, validation), (props.as === 'select' ? styles.select : '')].join(' ')

const getTabIndex = readOnly => readOnly ? '-1' : null
const validateInitializer = (props, setValidation) => () => {
  if (props.hasOwnProperty('validationRules')) {
    let validationResult;
    if (props.validationRules.find((rule) => {
      validationResult = rule(props.value);
      if (!validationResult.valid) {
        setValidation({
          isValid: false,
          errorMsg: validationResult.msg
        });
        return true;
      }
      return false;
    }) == null){
      setValidation({
      isValid: true,
      errorMsg: ''
    });
  }
  }
};
const InputForm = (props) => {

  const [validation, setValidation] = useState({
    isValid: true,
    errorMsg: false
  });

  useEffect(() => {
    if ((props.hasOwnProperty('onSelect') || props.validationTrigger === 'onChange') && props.value.length > 0) {
      validate();
    }
  }, [props.value]);

  const onChangeHandler = (text, {mask, onChange, name}) => {
    if (props.hasOwnProperty("onChange")) {
      callOnChange(text, mask, onChange, name)
    }
  };

  const validate = validateInitializer(props, setValidation)

  return (
    <fieldset
      className={[styles.inputContainer, props.className, (props.as === 'select' ? styles.select : '')].join(' ')}>
      <input
        onClick={(e) => props.onClick ? props.onClick(e) : null}
        className={getInputStyle(props, validation)}
        type={props.type}
        onChange={event => onChangeHandler(event.target.value, props)}
        value={props.mask ? props.mask(props.value) : props.value}
        maxLength={props.maxLength}
        required
        onBlur={validate}
        readOnly={props.readonly}
        tabIndex={getTabIndex(props.readonly)}
        onKeyPress={props.onKeyPress}
        valid={'' + !(props.isValid === false || (props.isValid !== false && !validation.isValid))}
        id={props.id}
        disabled={props.disabled}
      />
      {props.as === 'select' ? <i className={"icon icon-seta-baixo-p"}/> : null}
      <label className={styles.floatLabel}>
        {props.typeDocument}
        {props.tooltip && <Tooltip  className={styles.tooltip}>{props.tooltip}</Tooltip>}
      </label>
      <span
        className={getErrorMessageClass(props.isValid, validation)}
      >
        {validation.errorMsg ? validation.errorMsg : props.errorMsg}
      </span>
    </fieldset>
  );
};

export default memo(InputForm);
